import { render, staticRenderFns } from "./FrenchWindowImpacts.vue?vue&type=template&id=a8f7a7a4&scoped=true"
import script from "./FrenchWindowImpacts.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f7a7a4",
  null
  
)

export default component.exports